import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/Constants';

export const requestPhoneChange = createAsyncThunk('requestPhoneChange', async (payload) => {
    const token = localStorage.getItem('Token');
    const headers = {
        Authorization: token,
        'Content-Type': 'application/json',
    };
    const response = await axios.put(`${BASE_URL}/v1/common/requestPhoneChange`, payload, { headers });
    return response.data;
});

export const verifyPhoneChange = createAsyncThunk('verifyPhoneChange', async (payload) => {
    const token = localStorage.getItem('Token');
    const headers = {
        Authorization: token,
        'Content-Type': 'application/json',
    };
    const response = await axios.put(`${BASE_URL}/v1/common/otpVerifications`, payload, { headers });
    return response.data;
});

const ChangePhoneSlice = createSlice({
    name: 'changePhone',
    initialState: {
        requestData: null,
        verifyData: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearChangePhone: (state) => {
            state.requestData = null;
            state.verifyData = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(requestPhoneChange.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(requestPhoneChange.fulfilled, (state, action) => { state.loading = false; state.requestData = action.payload; })
            .addCase(requestPhoneChange.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
            .addCase(verifyPhoneChange.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(verifyPhoneChange.fulfilled, (state, action) => { state.loading = false; state.verifyData = action.payload; })
            .addCase(verifyPhoneChange.rejected, (state, action) => { state.loading = false; state.error = action.error.message; });
    },
});

export const { clearChangePhone } = ChangePhoneSlice.actions;
export default ChangePhoneSlice.reducer;
